/** Endpoints du profil utilisateur. */

import { apiFetch } from "@/api/client";

export type UserProfile = {
  id: string;
  email: string;
  email_verified_at: string | null;
  tier: "free" | "premium";
  is_admin: boolean;
  marketing_emails_opt_in: boolean;
  analytics_opt_in: boolean;
  ads_opt_in: boolean;
  created_at: string;
};

export type UpdateConsentsPayload = {
  marketing_emails_opt_in?: boolean;
  analytics_opt_in?: boolean;
  ads_opt_in?: boolean;
};

export type DataExport = {
  exported_at: string;
  user: {
    id: string;
    email: string;
    tier: "free" | "premium";
    email_verified_at: string | null;
    created_at: string;
    consent_cgu_version: string | null;
    consent_cgu_accepted_at: string | null;
    marketing_emails_opt_in: boolean;
    analytics_opt_in: boolean;
    ads_opt_in: boolean;
  };
  logements: {
    id: string;
    title: string;
    type: string;
    postal_code: string | null;
    city: string | null;
    construction_year: number | null;
    dpes: {
      id: string;
      state: string;
      payload: Record<string, unknown>;
      result: Record<string, unknown> | null;
      engine_version: string | null;
      created_at: string;
    }[];
  }[];
};


export function getMe() {
  return apiFetch<UserProfile>("/me");
}

export function updateConsents(payload: UpdateConsentsPayload) {
  return apiFetch<UserProfile>("/me", { method: "PATCH", body: payload });
}

export function changePassword(currentPassword: string, newPassword: string) {
  return apiFetch<{ message: string }>("/me/password", {
    method: "POST",
    body: { current_password: currentPassword, new_password: newPassword },
  });
}

export function deleteAccount(password: string) {
  return apiFetch<{ message: string }>("/me", {
    method: "DELETE",
    body: { password },
  });
}

export function exportMyData() {
  return apiFetch<DataExport>("/me/export");
}
